import Image from "next/image";
import Head from "next/head";
import styles from "./mains-crash-course.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
// import Interest from "../../components/might-be-interest";
import crashcourse from "../../assets/images/upsc/upsc-mainscrash-course-web-banner.jpg";
import Mobcrashcourse from "../../assets/images/upsc/upsc-mainscrash-course-mob-banner.jpg";
import Link from "next/link";
import check from "../../assets/images/upsc/check.png";

const Two_Year_Classroom_Programme = () => {

    return (  
        <>
  
        <Head>
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index, nofollow" />
            <meta name="robots" content="index, nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>Shankar IAS Academy | UPSC Mains Crash Course 2025</title>
            <meta name="title" content="Shankar IAS Academy | UPSC Mains Crash Course 2025" />
            <meta name="keywords" content="UPSC Mains Crash Course ,UPSC Crash Course for Mains ,UPSC GS Mains Crash Course ,Mains GS Crash Course,Online UPSC Mains Crash Course, UPSC Mains Crash Course Syllabus,UPSC Mains Crash Course Fees, UPSC Mains Crash Course Admission , UPSC Mains Crash Course Details ,Best Crash Course for UPSC Mains  " />
            <meta name="description" content="Join Shankar IAS Academy’s UPSC Mains Crash Course 2025. Intensive revision, answer writing, expert mentorship & test series for final preparation." />
            <link rel="canonical" href="https://www.shankariasacademy.com/upsc-mains-crash-course/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Shankar IAS Academy | UPSC Mains Crash Course 2025" />
            <meta property="og:description" content="Join Shankar IAS Academy’s UPSC Mains Crash Course 2025. Intensive revision, answer writing, expert mentorship & test series for final preparation." />
            <meta property="og:url" content="https://www.shankariasacademy.com/upsc-mains-crash-course/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

        <Navbar title="upsc" />
        
        <div className="container">

            <div className="row">
            <div className="col pt-3 pt-md-4">
                <h1 className={`${styles.pagemaintitle}`}>UPSC Mains Crash Course 2025</h1>
            </div>
            </div>

           <div className="row d-none d-md-block">
            <div className="col mb-3">
              <Image
                src={crashcourse}
                alt="UPSC Mains Crash Course 2024"
                title="UPSC Mains Crash Course 2024"
                className="img-fluid w-100"
              />
            </div> 
          </div> 

       <div className="row d-block d-md-none">
          <div className="col mb-3">
              <Image
                src={Mobcrashcourse}
                alt="UPSC Mains Crash Course 2024"
                title="UPSC Mains Crash Course 2024"
                className="img-fluid w-100"
              />
            </div>
          </div>

        </div>
        
  

        {/* table */}
            

  <section className="" style={{background: "#F4F6F8 0% 0% no-repeat padding-box" , opacity: "1"}}>
        <div className="container mt-5 mb-5">
           <div className="col-12 col-xl-12 ">   
           <div className="row">
                <div class=" col-12 col-xl-12 d-none d-lg-block " style={{backgroundColor:"#f4f6f8"}}>
                   <div class="py-2" style={{backgroundColor: "#001e62"}}><h2 className={`${styles.tabletitle}`}>UPSC Mains Crash Course 2025</h2></div>
                   <div className="d-none d-lg-block ">
                         <table class="table">
                              <thead class="table" style={{backgroundColor:"#818C98"}}>
                                    <tr>
                                        <td className={`${styles.tableheading}`}>Batch</td>
                                        <td className={`${styles.tableheading}`}>Starts On<br/></td>
                                        <td className={`${styles.tableheading}`}>Fees<br/></td>
                                        <td className={`${styles.tableheading}`}>Admission<br/></td>
                                    </tr>
                                </thead>
                               <tbody>
                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Regular(Hybrid)</td>
                                        <td className={`${styles.tablepara}`}>05th June 2025 <br/>08:00 am - 01:30 pm</td>
                                        <td className={`${styles.tablepara}`}>₹38,000</td>
                                        <td  className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>
                              </tbody>
                        </table>
                        </div>
          
            </div>
            </div>
            </div>
            </div>
</section>

{/* <div className="container-fluid d-none d-lg-block"
                style={{background: "transparent linear-gradient(180deg, #F4F6F8 0%, #F4F6F8 75%, #F4F6F800 100%) 0% 0% no-repeat padding-box", opacity: "1",}}>
                  <div className="container">                   
                    <div className="row ">
                        <div className="col-12 col-xl-6 col-lg-8 col-md-10 mx-auto text-start mb-5">
                        <h2 className={`${styles.sectiontitle} pt-2`}>Mains Crash Course Details </h2>
                            <hr />
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />NUMBER OF SESSIONS – 70+</p>
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />COURSE DURATION – 40 days</p>
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />NUMBER OF TEST-25 TEST</p>
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />Subjects to be covered:</p>
                             
                              <div className="row">
                                <div className="col-md-12 col-lg-8 col-xl-8 col-12 pt-3 pe-xl-0">
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Governance</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Agriculture</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Ethics</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Internal security</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Society in India</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Post Independence Consolidation</p>
                                </div> 
                                <div className="col-md-12 col-lg-6 col-xl-4 col-12 pt-3 ps-xl-0">
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Bilateral Relations</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Economics</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>World History</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Essay</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>World Constitution</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Rights Issues</p>
                                </div>
                              </div>
                              
                        </div>

                        
                      </div>
                  </div>
</div> */}

        {/* Mobile View */}

<section className=" " style={{background: "" , opacity: "1"}}>
    <div className="container mb-5">
        <div className="col-12 col-xl-12 ">   
        <div className="row">
     
        <div class=" col-12 col-xl-12 d-block d-md-none" style={{backgroundColor:"#f4f6f8"}}>
          <div class="py-2" style={{backgroundColor: "#001e62"}}><h2 className={`${styles.tabletitle}`}>UPSC Mains Crash Course 2025</h2></div>
                    <div class="row border-bottom">
								<div class={`${styles.tableheading} col-12 col-md-3 d-none d-md-block `}>Batch</div>
								<div class={`${styles.tableheading} col-12 col-md-3 d-none d-md-block`}>Starts On</div>
								<div class={`${styles.tableheading} col-12 col-md-3 d-none d-md-block`}>Fees</div>
                                <div class={`${styles.tableheading} col-12 col-md-3 d-none d-md-block`}>Admission</div>				
					</div>
                 
                <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none">Batch</div>
                    <div class="col-6 pt-3 col-md-3"><b>Regular(Hybrid)</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Starts On</div>
                    <div class="col-6 pt-3 col-md-3">05th June 2025<br/>08:00 am - 01:30 pm</div>
                    <div class="col-6 pt-3 d-block d-md-none">Fees</div>
                    <div class="col-6 pt-3 col-md-3"><b>₹38,000</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Admission</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>

                </div> 
               
                                  
	      </div>
        </div>
        </div>
        </div>
</section>

{/* <div className="container-fluid d-block d-md-none"
                style={{background: "transparent linear-gradient(180deg, #F4F6F8 0%, #F4F6F8 75%, #F4F6F800 100%) 0% 0% no-repeat padding-box", opacity: "1",}}>
                  <div className="container">                   
                    <div className="row ">
                        <div className="col-12 col-xl-6 col-lg-8 col-md-10 mx-auto text-start mb-5">
                        <h2 className={`${styles.sectiontitle} pt-2`}>Mains Crash Course Details </h2>
                            <hr />
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />NUMBER OF SESSIONS – 70+</p>
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />COURSE DURATION – 40 days</p>
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />NUMBER OF TEST-25 TEST</p>
                            <p className={`${styles.tablepara1} p-1`}><Image src={check} alt="check" className={`${styles.phoneiconcss} img-fluid pe-2`} />Subjects to be covered:</p>
                             
                              <div className="row">
                                <div className="col-md-12 col-lg-8 col-xl-8 col-12 pt-3 pe-xl-0">
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Governance</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Agriculture</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Ethics</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Internal security</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Society in India</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Post Independence Consolidation</p>
                                </div> 
                                <div className="col-md-12 col-lg-6 col-xl-4 col-12 pt-3 ps-xl-0">
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Bilateral Relations</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Economics</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>World History</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Essay</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>World Constitution</p>
                                <p className={`${styles.aboutparagraph1} `}> <span className={`${styles.dot} pe-2`}>*</span>Rights Issues</p>
                                </div>
                              </div>
                              
                        </div>

                        
                      </div>
                  </div>
</div> */}



               <div className="container pt-2 pt-lg-3 mb-4 mb-md-5">
                    <div className="row" id="optionaltest">
                        <div className="col-xl-4 col-md-6 col-12 py-xl-2 pt-3">
                            <div className="h-100" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                                <ul>
                                    <li className={`${styles.sectiontitle2} mb-0`}>Classes on<br/>
                                    Mains only subjects</li>                     
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 col-12 py-xl-2 pt-3">
                            <div className="h-100" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                            <ul>
                                    <li className={`${styles.sectiontitle2} mb-0`}>Mains 2025<br/>
                                    test series</li>                               
                            </ul>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 col-12 py-xl-2 pt-3">
                            <div className="h-100" style={{background: '#FFF3D3 0% 0% no-repeat padding-box', opacity: '1'}}>
                            <ul>
                                    <li className={`${styles.sectiontitle2} mb-0`}>Books for<br/>
                                    Mains only subjects</li>                               
                            </ul>
                            </div>
                        </div>
                    </div>
                </div>
               


       
        <Footer />                      
        </>
    )
}
export default Two_Year_Classroom_Programme
